import { SerializedError } from '@reduxjs/toolkit';
import classNames from 'classnames';
import React from 'react';

import { Spinner } from '@myhealth-raccoon/components';

type Props = {
    error?: Error | SerializedError;
    className?: string;
    hideText?: boolean;
};

export const PleaseWait = ({ error, className, hideText }: Props) => {
    return (
        <div className={classNames('p-4', className)}>
            {!hideText && <h1 className={classNames('mb-2.5 text-2xl font-semibold text-gray-900')}>Please wait</h1>}
            {error ? (
                <pre className="text-error whitespace-pre-wrap">
                    {error.name}: {error.message}
                </pre>
            ) : (
                <Spinner className="mx-auto block w-fit" />
            )}
        </div>
    );
};
